import Header from "../../components/header";
import StyleFeedOverview from "../../components/style/style-feed-overview";

const StylePage = () => {
  return (
    <>
      <Header />
      <StyleFeedOverview />
    </>
  );
};

export default StylePage;
